
/**
 * 问题理解 API 封装
 * 对应后端：server/routes/api/problemUnderstanding.js
 */

/**
 * 问题理解主接口（出理解卡）
 * @param {Object} data
 * @param {string} data.raw_query 用户输入的技术问题
 * @param {Object} [data.extracted_fields] 已抽取字段
 * @param {string} [data.understanding_sentence] 理解句
 * @param {Object} [data.suggestion] 补充问题
 * @returns {Promise<Object>}
 */
export async function understandProblem(data) {
  const response = await fetch('/api/problemUnderstanding/understand', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
}

/**
 * 理解句接口（非流式）：一次返回完整理解句
 * @param {Object} data { raw_query, selected_options }
 * @param {Object} handlers
 * @param {(content: string) => void} [handlers.onSentence] 收到完整理解句
 * @param {(data: Object) => void} [handlers.onDone] 完成，返回 { sentence }
 * @param {(err: Error) => void} [handlers.onError] 出错
 */
export async function streamUnderstanding(data, { onSentence, onDone, onError } = {}) {
  const response = await fetch('/api/problemUnderstanding/understand-stream', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data2 = await response.json();
  if (data2.sentence) {
    onSentence?.(data2.sentence);
  }
  onDone?.(data2);
}

/**
 * 问题列表接口（独立调用，只返回 extracted_fields + questions[]）
 * @param {Object} data { raw_query, selected_options, force_suggestion }
 * @returns {Promise<Object>} { extracted_fields, questions }
 */
export async function getQuestions(data) {
  const response = await fetch('/api/problemUnderstanding/understand-questions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
}
